.ds{padding:0.5rem;}